import operationsService from '../services/Operation/operationsService'
import { URLapiParty } from './api'

export function fetchLoans(userToken) {
  return new Promise((resolve) => {
    operationsService
      .get(userToken)
      .then((data) => {
        resolve(data)
      })
      .catch((error) => console.log(error))
  })
}

export function deleteUser(data) {
  return new Promise((resolve) => {
    URLapiParty.post('/user/delete?api-version=1.0', data)
      .then((data) => {
        resolve(data)
      })
      .catch((error) => resolve(error))
  })
}

export function countryList() {
  return new Promise((resolve) => {
    URLapiParty.get(`country/list?api-version=1.0`)
      .then((data) => {
        resolve(data)
      })
      .catch((error) => console.log(error))
  })
}

export function addLoan(data) {
  return new Promise((resolve) => {
    URLapiParty.post('user/addoperationstouser?api-version=1.0', data)
      .then((data) => {
        resolve(data)
      })
      .catch((error) => resolve(error))
  })
}

export function removeoperationsfromuser(data) {
  return new Promise((resolve) => {
    URLapiParty.post('user/removeoperationsfromuser?api-version=1.0', data)
      .then((data) => {
        resolve(data)
      })
      .catch((error) => resolve(error))
  })
}

export function updateuser(data) {
  return new Promise((resolve) => {
    URLapiParty.post('user/update?api-version=1.0', data)
      .then((data) => {
        resolve(data)
      })
      .catch((error) => resolve(error))
  })
}

export function switchaccountenabled(data) {
  return new Promise((resolve) => {
    URLapiParty.post('/user/switchaccountenabled?api-version=1.0', data)
      .then((data) => {
        resolve(data)
      })
      .catch((error) => resolve(error))
  })
}

export function getall(userType) {
  return new Promise((resolve) => {
    URLapiParty.get(`user/getall?UserType=${userType}&api-version=1.0`)
      .then((data) => {
        resolve(data)
      })
      .catch((error) => resolve(error))
  })
}
